module.exports = __webpack_public_path__ + "img/CA.d32a86c7.png";